import { render, staticRenderFns } from "./UserEditTabProduct.vue?vue&type=template&id=9a83a00c&"
import script from "./UserEditTabProduct.vue?vue&type=script&lang=js&"
export * from "./UserEditTabProduct.vue?vue&type=script&lang=js&"
import style0 from "./UserEditTabProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports